<script lang="ts" setup>
import { ref } from 'vue'
import Modal from './Modal.vue'
import Button from './Button.vue'
defineProps<{
  title: string
  content: string
  hideCta: boolean
}>()

const showing = ref(true)
</script>

<template>
  <Modal :title="title" v-if="showing" @close="showing = false">
    <div v-html="content" class="Modal__SimpleContentContainer"></div>
    <Button v-if="!hideCta" @click="showing = false">Okay</Button>
  </Modal>
</template>

<style>
.Modal__SimpleContentContainer {
  margin-right: 45px;

  & .Modal__Panel {
    margin-right: calc(-45px - var(--grid-gap));
  }
}
</style>
